import { useAuth } from "hooks/useAuth";
import { useAppSelector } from "hooks/useRedux";
import mixpanel from "mixpanel-browser";
import { RootState } from "store";

const useMixpanel = () => {
  const authContext = useAuth();
  const businessState = useAppSelector((state: RootState) => state.businesses);

  const trackEvent = (name: string, options?: any) =>
    mixpanel?.track(`bwp-${name}`, {
      userId: authContext?.user?.uuid,
      businessId: businessState?.business?.uuid,
      ...options,
    });
  return { trackEvent };
};

export default useMixpanel;
